import { IViewAcceleration } from '~src/dataAcceleration/types/IViewAcceleration';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IWorkbookParent } from '../../../workbook/ServerApi/types/IWorkbook';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IRecent } from '../types/IRecent';
import { IViewUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { IView } from '../types/IView';
import { INamedItem, ITypedItem } from '../types/resourceParts';

export interface IGetViewsParams extends IGetItemsParams {
}

export interface IGetViewsResult extends IGetItemsResult {
  views?: IView[];
  workbooks?: IWorkbookParent[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  users?: IUser[];
  maxStats?: IViewUsageInfo;
  favorites?: string[];
  recents?: IRecent[];
  viewAccelerations?: IViewAcceleration[];
}

export class GetViewsRequest extends Request<IGetViewsParams, IGetViewsResult> {
  constructor(params: IGetViewsParams) {
    super('getViews', params);
  }
}
